import { useState } from 'react';

const useBulkPDFJobsFilter = () => {
  const [currentQuery, setCurrentQuery] = useState({ page: 1, limit: 10, type: 'BULK_PDF_DOWNLOAD' });

  const handlePaginationChange = (page, limit) => setCurrentQuery({ ...currentQuery, page: page, limit: limit });

  return {
    currentQuery,
    handlePaginationChange,
  };
};

export default useBulkPDFJobsFilter;
